import { render, staticRenderFns } from "./m-modal-language-switcher.vue?vue&type=template&id=196e8374&"
import script from "./m-modal-language-switcher.vue?vue&type=script&lang=js&"
export * from "./m-modal-language-switcher.vue?vue&type=script&lang=js&"
import style0 from "./m-modal-language-switcher.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports